import type { Analysis, Mode, QuantizeMeta, Status } from '../types';
import { fmtTime } from '../format';

interface Props {
  mode: Mode;
  status: Status;
  name: string;
  duration: number;
  analysis: Analysis | null;
  quantized: boolean;
  quantMeta: QuantizeMeta | null;
  recElapsed: number;
  serverOk: boolean | null;
  onMode: (m: Mode) => void;
  onOpenStudio?: () => void;
  /* comptes (masqués si non configurés) */
  accountEnabled?: boolean;
  accountEmail?: string | null;
  onAccount?: () => void;
  onCloudSave?: () => void;
  cloudBusy?: boolean;
}

export default function TopBar(p: Props) {
  const empty = p.status === 'empty';
  const rec = p.status === 'recording';
  const bpm = p.analysis?.bpm;

  return (
    <header className="topbar">
      <div className="brand">
        Quan<em>time</em>
      </div>
      <div className="vrule" />

      <div className="filemeta">
        <span className="name" style={{ color: empty ? 'var(--dim)' : undefined }}>
          {empty ? 'Aucune prise' : rec ? 'Nouvelle prise' : p.name || 'prise'}
        </span>
        {!empty && (
          <span className="sub">{fmtTime(rec ? p.recElapsed : p.duration)}</span>
        )}
        {!empty && !rec && bpm ? (
          <span className={`sub${p.quantized ? ' ok' : ''}`}>
            {bpm.toFixed(1).replace('.', ',')} BPM
            {p.quantized ? ' · calé' : ''}
          </span>
        ) : null}
        {p.analysis?.key ? <span className="sub">{p.analysis.key.name}</span> : null}
      </div>

      <div className="grow" />

      {p.accountEnabled && p.accountEmail && p.onCloudSave && !empty && !rec && (
        <button
          className="btn sm"
          onClick={p.onCloudSave}
          disabled={p.cloudBusy}
          title="Sauvegarder cette prise dans ma bibliothèque (cloud)"
        >
          {p.cloudBusy ? '☁ …' : '☁ Sauvegarder'}
        </button>
      )}
      {p.accountEnabled && p.onAccount && (
        <button
          className={`btn sm${p.accountEmail ? '' : ' ghost'}`}
          onClick={p.onAccount}
          title={p.accountEmail ? `Compte : ${p.accountEmail} · bibliothèque` : 'Se connecter / créer un compte'}
        >
          👤{p.accountEmail ? '' : ' Se connecter'}
        </button>
      )}
      {p.onOpenStudio && (
        <button
          className="btn sm"
          onClick={p.onOpenStudio}
          disabled={rec}
          title={rec ? 'Termine l’enregistrement avant de changer de mode' : 'Studio multipiste (timeline)'}
        >
          Studio ▸
        </button>
      )}

      <div className="seg" role="tablist" aria-label="Mode d'interface">
        <button
          role="tab"
          aria-selected={p.mode === 'troubadour'}
          className={p.mode === 'troubadour' ? 'on' : ''}
          onClick={() => p.onMode('troubadour')}
        >
          Troubadour
        </button>
        <button
          role="tab"
          aria-selected={p.mode === 'maestro'}
          className={p.mode === 'maestro' ? 'on alt' : ''}
          onClick={() => p.onMode('maestro')}
        >
          Maestro
        </button>
      </div>

      <span
        className={`badge${p.serverOk === false ? ' off' : p.serverOk === null ? ' wait' : ''}`}
        title={p.serverOk === false ? 'Le serveur de traitement ne répond pas' : 'Serveur de traitement joignable'}
      >
        {p.serverOk === false ? '● hors ligne' : p.serverOk === null ? '● …' : '● serveur'}
      </span>
    </header>
  );
}
